module.exports = __webpack_public_path__ + "static/media/gifascii.3c645a00.jpg";